import useSWR, { SWRResponse } from 'swr'
import { Card } from '@mui/material'
import { useParams } from 'react-router-dom'
import AdSetsTable from './AdSetsTable'
import axiosInstance from '../../../../utils/axiosInstance'
import { COLUMNS } from './constants'

const AdsetsKPIs = () => {
  const { id: campaignId } = useParams()
  const { data, isLoading }: SWRResponse = useSWR(`/meta/adsets/${campaignId}`, axiosInstance)

  return (
    <Card sx={{ mt: '20px' }}>
      <AdSetsTable isLoading={isLoading} columns={COLUMNS} data={data?.data} />
    </Card>
  )
}

export default AdsetsKPIs
